import type { Resource } from '../../';
export const order_orderSummary_tax: Resource = {"default":"Tax"};
